.releaseHeader {
  margin-bottom: 8px;
}

.currentVersion {
  color: #666;
  margin-bottom: 0;
}

.releaseControls {
  align-items: flex-end;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 20px;
}

.releaseSelector {
  margin-bottom: 0;
  max-width: 320px;
  width: 100%;
}

.selectorHelp {
  color: #666;
  display: block;
  margin-top: 5px;
}

.actions {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
}

.release {
  margin-bottom: 30px;
}

.notes {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  min-height: 60px;
  overflow-wrap: anywhere;
  padding: 16px;
}

.emptyNotes {
  color: #666;
  font-style: italic;
}

.metadata {
  color: #666;
  display: block;
  margin-top: 8px;
}

@media (max-width: 760px) {
  .releaseControls {
    align-items: stretch;
    flex-direction: column;
  }

  .releaseSelector {
    max-width: none;
  }

  .releaseControls button {
    align-self: flex-start;
  }
}
